import type { ReactNode } from "react";
import { motion, type HTMLMotionProps } from "motion/react";
import { springSnappy } from "../lib/motion";

type Variant = "primary" | "musical" | "warm" | "outline" | "ghost";
type Size = "sm" | "md" | "lg";

const variants: Record<Variant, string> = {
  primary: "bg-terra hover:bg-terra-hover text-white",
  musical: "bg-sage hover:bg-sage-hover text-white",
  warm: "bg-honey hover:bg-honey-hover text-ink",
  outline:
    "bg-surface border border-edge-strong text-ink hover:bg-muted",
  ghost: "text-ink hover:bg-muted",
};

const sizes: Record<Size, string> = {
  sm: "px-4 py-2 text-sm",
  md: "px-6 py-3 text-base",
  lg: "px-8 py-4 text-lg",
};

type Props = HTMLMotionProps<"button"> & {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
};

export default function Button({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...rest
}: Props) {
  return (
    <motion.button
      className={`rounded-xl font-medium transition-colors ${variants[variant]} ${sizes[size]} ${className}`}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.97 }}
      transition={springSnappy}
      {...rest}
    >
      {children}
    </motion.button>
  );
}
